import { hide, show, toggle } from 'slidetoggle';
// import $ from "jquery";


/* Open all PDF links in a new window */
document.querySelectorAll('a').forEach((linkElem: Element, index) => {
	if(linkElem.hasAttribute('href') && linkElem.getAttribute('href').endsWith('.pdf')) {
		linkElem.setAttribute('target', '_blank');
	}
});

/* mailencrypting */
setTimeout(function () {
	let mailElement = document.querySelectorAll('[data-madr1]:not(.madr-done)');

	mailElement.forEach((mail: HTMLElement, index) => {
		const maddr = mail.getAttribute('data-madr1') + '@' + mail.getAttribute('data-madr2') + '.' + mail.getAttribute('data-madr3');
		const linktext = mail.getAttribute('data-linktext') ? mail.getAttribute('data-linktext') : maddr;

		const a = document.createElement('a')
		a.setAttribute('href', `mailto:${maddr}`)
		a.innerHTML = linktext;

		if (mail.parentElement) mail.parentElement.appendChild(a);
		mail.classList.add('madr-done');
		mail.style.display = 'none';
	});
}, 500);

/* Go to top button */
if(document.querySelector('#to-shine-to-top')) {
	document.querySelector('#to-shine-to-top').addEventListener('click', (e) => {
		e.preventDefault();
	
		window.scrollTo({
			top: 0,
			left: 0,
			behavior: 'smooth'
		});
	})
}

const navheader = document.querySelector('header');
const navheight = navheader.offsetHeight;
window.addEventListener('scroll', function (event) {
	const bc = document.querySelector('.to-shine-page-breadcrumb');
	if(bc != null) {
		(bc as HTMLElement).style.top = `${navheader.offsetHeight - 1}px` ;

		// if (window.scrollY > navheight) {
		// 	bc.classList.add('bg-light' , 'shadow');
		// } else {
		// 	bc.classList.remove('bg-light' , 'shadow');
		// }
	}

	const toTop = document.querySelector("#to-shine-to-top");
	if(toTop != null) {
		/* show / hide scroll to top button */
		if (window.scrollY > 200) {
			toTop.classList.add('to-shine-top-visible');
		} else {
			toTop.classList.remove('to-shine-top-visible');
		}
	}
	
}, false);
// breadcrumb

/* opens sub navs and mobile navs */
document.querySelectorAll('.to-shine-navopener').forEach((openerElem: HTMLElement, index) => {
	openerElem.addEventListener('click', (e) => {
		const targetElem = e.currentTarget as HTMLElement;
		const targetParent = targetElem.parentElement.parentElement;

		if(!targetParent.classList.contains('to-shine-active')) {
			if(targetElem.closest('.has-child').classList.contains('to-shine-active')) {
				document.querySelector('.to-shine-active').classList.remove('to-shine-active')
				hide(document.querySelector('.to-shine-active ul') as HTMLElement, {});
			}
			targetParent.classList.toggle('to-shine-active');
			show(targetParent.querySelector('ul') as HTMLElement, {});
		} else {
			targetParent.classList.toggle('to-shine-active');
			hide(targetParent.querySelector('ul') as HTMLElement, {});
		}
	})
})


const bc = document.querySelector('.to-shine-page-breadcrumb');
if(bc != null){
	document.querySelector('.to-shine-page-breadcrumb span a:last-child').classList.add('last');
	document.querySelector('.to-shine-page-breadcrumb span:last-child').classList.add('last');
	if(document.querySelector('.to-shine-page-breadcrumb span .to-shine-page-breadcrumb-link:nth-last-child(3)') != null) {
		document.querySelector('.to-shine-page-breadcrumb span .to-shine-page-breadcrumb-link:nth-last-child(3)').classList.add('second-last');
	}
	bc.classList.toggle('to-shine-page-breadcrumb-shortened', (document.querySelector('.to-shine-page-breadcrumb-link') != null || document.querySelectorAll('.to-shine-page-breadcrumb-link').length > 2))
	document.querySelector('.to-shine-page-breadcrumb-trigger').addEventListener('click', () => {
		bc.classList.toggle('to-shine-page-breadcrumb-shortened')
	})
}


// language selector
["desktop", "mobile"].forEach(view => {
  const activeLang = document.querySelector<HTMLElement>(
    `.subheader.${view} .dropdown-menu li.active`
  );
  const langText = activeLang?.textContent?.trim() ?? "";
  const target = document.querySelector<HTMLElement>(
    `.subheader.${view} .current-taal .current-selected-lang`
  );
  if (target) target.textContent += langText;
});

// Add external/internal classes to links in content
const selectors = [".contentdiv p a", ".contentdiv > ul li a"];

selectors.forEach(selector => {
  document.querySelectorAll<HTMLAnchorElement>(selector).forEach(link => {
    const isExternal = link.host !== window.location.host;
    link.classList.add(isExternal ? "external" : "internal");
  });
});



////////// Menu script for desktop and mobile //////////
/* ==== Types ==== */
interface DataItem {
  title: string;
  desc: string;
  img?: string | null;
  link?: string | null;
  enabled?: boolean;
  target?: "_self" | "_blank" | null;
  children?: DataItem[];
}

/* Globale data uit pagina (script-tags) */
declare const data: DataItem[];
/** Tweede (gescope) mobiele menudata */
declare const mobileMenuData1: DataItem[];

/* ==== Helpers ==== */
const $ = <T extends Element = Element>(s: string, r: Document | Element = document): T | null =>
  r.querySelector<T>(s);

const $$ = <T extends Element = Element>(s: string, r: Document | Element = document): T[] =>
  Array.prototype.slice.call(r.querySelectorAll<T>(s));

const isHTMLElement = (node: Element | null): node is HTMLElement => !!node && node instanceof HTMLElement;

/** Attributen/eigenschappen toepassen; 'style' mag string (cssText) of object zijn */
function applyAttrs<T extends HTMLElement>(n: T, attrs: Record<string, any>): void {
  for (const key in attrs) {
    const val = (attrs as any)[key];
    if (key === "style") {
      if (typeof val === "string") {
        n.style.cssText = val; // string → cssText
      } else if (val && typeof val === "object") {
        Object.assign(n.style, val as Partial<CSSStyleDeclaration>); // object → style props
      }
    } else if (key in n) {
      (n as any)[key] = val;
    } else {
      n.setAttribute(key, String(val));
    }
  }
}

/**
 * el(): maak element met attrs + children.
 * We Omitten 'style' en voegen een union terug zodat string/object is toegestaan.
 * attrs is optioneel om type-conflicten met {} te vermijden.
 */
function el<K extends keyof HTMLElementTagNameMap>(
  tag: K,
  attrs?: (
    Omit<Partial<HTMLElementTagNameMap[K]>, "style"> &
    { style?: string | Partial<CSSStyleDeclaration> } &
    Record<string, any>
  ),
  ...kids: Array<Node | string | null | undefined>
): HTMLElementTagNameMap[K] {
  const n = document.createElement(tag);
  if (attrs) applyAttrs(n as HTMLElement, attrs as any);

  // eenvoudige append-loop (zonder .flat)
  for (let i = 0; i < kids.length; i++) {
    const k = kids[i];
    if (k == null) continue;
    n.append(typeof k === "string" ? document.createTextNode(k) : k);
  }
  return n;
}

/* ==== State ==== */
let activeIndex: number | null = null;
const state: { desk: DataItem[]; mob: DataItem[]; mob1: DataItem[] } = { desk: [], mob: [], mob1: [] };

/* ==== Core ==== */
const sanitize = (s?: string) =>
  (s || "")
    .replace(/"/g, "'")
    .replace(/[<>]/g, m => ({ "<": "(", ">": ")" }[m as "<" | ">"]!))
    .replace(/&/g, "en")
    .replace(/[/:]/g, "-")
    .replace(/[^\w\s\-()']/g, "")
    .trim();

const altText = (i?: DataItem | null) =>
  !i || (!i.title && !i.desc) ? "Afbeelding" : sanitize(i.title) + (i.desc ? ` – ${sanitize(i.desc)}` : "");

const extIcon = () =>
  el("i", {
    className: "fa-solid fa-arrow-up-right",
    ariaHidden: "true",
    style: "margin-left:5px;font-size:15px"
  });

const closeMegamenu = (): void => {
  const m = $("#submenu") as HTMLElement | null;
  if (!m || m.classList.contains("d-none")) return;
  m.classList.add("d-none");
  $$("#main-menu .nav-item").forEach(b => b.classList.remove("active"));
  activeIndex = null;

  // HIDE OVERLAY
  $("#menu-overlay")?.classList.add("d-none");
};

/* ==== Sluit alle dropdowns, ook varianten met alleen toggle/menu .show (BS4/5) ==== */
function closeDropdowns(): void {
  const toggleSel = [
    '[data-bs-toggle="dropdown"].show',
    '[data-toggle="dropdown"].show',
    '.dropdown-toggle.show',
    '[data-bs-toggle="dropdown"][aria-expanded="true"]',
    '[data-toggle="dropdown"][aria-expanded="true"]',
    '.dropdown-toggle[aria-expanded="true"]'
  ].join(",");

  const toggles = document.querySelectorAll<HTMLElement>(toggleSel);

  for (let i = 0; i < toggles.length; i++) {
    const t = toggles[i];
    try {
      const hasBootstrap = (window as any).bootstrap?.Dropdown;
      if (hasBootstrap) {
        const Dropdown = (window as any).bootstrap.Dropdown;
        (Dropdown.getInstance(t) || new Dropdown(t)).hide();
      } else {
        t.classList.remove("show");
        t.setAttribute("aria-expanded", "false");
        const dd = t.closest(".dropdown");
        const next = t.nextElementSibling;
        const menu =
          (dd?.querySelector(".dropdown-menu.show") as HTMLElement | null) ||
          (isHTMLElement(next) && next.classList.contains("dropdown-menu") ? next : null) ||
          (t.parentElement?.querySelector(".dropdown-menu.show") as HTMLElement | null);
        menu && menu.classList.remove("show");
      }
    } catch {
      t.classList.remove("show");
      t.setAttribute("aria-expanded", "false");
      const dd = t.closest(".dropdown");
      (dd?.querySelector(".dropdown-menu.show") as HTMLElement | null)?.classList.remove("show");
      (t.parentElement?.querySelector(".dropdown-menu.show") as HTMLElement | null)?.classList.remove("show");
    }
  }

  const shown = document.querySelectorAll<HTMLElement>(".dropdown.show");
  for (let i = 0; i < shown.length; i++) {
    const dd = shown[i];
    dd.classList.remove("show");
    (dd.querySelector(".dropdown-menu.show") as HTMLElement | null)?.classList.remove("show");
    const expanded = dd.querySelectorAll<HTMLElement>('[aria-expanded="true"]');
    for (let j = 0; j < expanded.length; j++) expanded[j].setAttribute("aria-expanded", "false");
  }

  const legacy = document.querySelectorAll<HTMLElement>(".open, .is-open");
  for (let i = 0; i < legacy.length; i++) legacy[i].classList.remove("open", "is-open");
}

function updateInfo(item: DataItem): void {
  const info = $("#info-panel") as HTMLElement | null;
  const title = $("#item-title") as HTMLElement | null;
  const desc = $("#item-desc") as HTMLElement | null;
  const img = $("#item-img") as HTMLImageElement | null;
  if (!info || !title || !desc) return;

  title.textContent = item.title || "";
  desc.textContent = item.desc || "";

  if (img) {
    if (item.img) {
      img.src = item.img;
      img.alt = altText(item);
      img.style.display = "block";
      img.onerror = () => {
        img.style.display = "none";
        img.alt = "";
      };
    } else {
      img.style.display = "none";
      img.alt = "";
      img.removeAttribute("src");
    }
  }

const go = !!(item.link && item.enabled);
const maybeList: Array<HTMLElement | null> = [info, title, desc, $(".item-block") as HTMLElement | null, img];
for (let i = 0; i < maybeList.length; i++) {
  const n = maybeList[i];
  if (n) {
    // Only control via class
    n.classList.toggle("non-clickable", !go);
    n.classList.toggle("clickable", go);
  }
}

  if (go) {
    info.onclick = () =>
      item.target === "_blank" && item.link
        ? window.open(item.link, "_blank")
        : item.link
        ? ((location.href = item.link), undefined)
        : undefined;
    title.innerHTML = item.title || "";
    if (item.target === "_blank") title.append(extIcon());
  } else {
    info.onclick = null;
    title.textContent = item.title || "";
  }
}

/* ==== Gedeelde item-renderer (desktop/mobile) ==== */
function buildItemNode(
  item: DataItem,
  opts: { withDesc?: boolean; onEnterChild?: (child: DataItem) => void }
): HTMLLIElement {
  const withDesc = !!opts.withDesc;
  const onEnterChild = opts.onEnterChild;
  const title = el("div", { className: "item-title", textContent: item.title });
  const desc = el("div", { className: "item-desc", textContent: withDesc ? item.desc || "" : "" });
  const block = el("div", { className: "item-subblock" }, el("div", { className: "item-text" }, title, desc));
  const li = el("li", { className: "col" }) as HTMLLIElement;

  if (item.children && item.children.length) {
    title.append(el("span", { className: "caret" }));
    (block as HTMLElement).onclick = (e: MouseEvent) => {
      e.stopPropagation();
      onEnterChild && onEnterChild(item);
    };
    li.append(block);
  } else if (item.link && item.enabled) {
    const a = el("a", { className: "item-link", href: item.link, target: item.target || "_self" }) as HTMLAnchorElement;
    if (item.target === "_blank") title.append(extIcon());
    a.onclick = (e: MouseEvent) => e.stopPropagation();
    a.append(block);
    li.append(a);
  } else {
    li.append(block);
  }

  return li;
}

/* ==== Desktop (megamenu) ==== */
function renderMainMenu(): void {
  const menu = $("#main-menu") as HTMLElement | null;
  if (!menu) return;
  menu.innerHTML = "";
  const ul = el("ul", { className: "nav" });
  for (let i = 0; i < (data || []).length; i++) {
    const it = data[i];
    ul.append(
      el(
        "li",
        { className: `nav-item nav-${i}` },
        el("span", {
          className: "nav-link",
          textContent: it.title,
          onclick: (e: MouseEvent) => {
            e.stopPropagation();
            openLevel(i);
          }
        } as any)
      )
    );
  }
  menu.append(ul);
}

function openLevel(i: number): void {
  const submenu = $("#submenu") as HTMLElement | null;
  if (!submenu) return;
  closeDropdowns(); // sluit "Over ons"/andere dropdowns wanneer megamenu opent
  if (activeIndex === i) {
    closeMegamenu();
    return;
  }

  // SHOW OVERLAY
  $("#menu-overlay")?.classList.remove("d-none");

  $$("#main-menu .nav-item").forEach(b => b.classList.remove("active"));
  const items = $$("#main-menu .nav-item");
  const btn = items[i] as HTMLElement | undefined;
  if (btn) btn.classList.add("active");
  submenu.classList.remove("d-none");

  activeIndex = i;
  state.desk = [data[i]];
  updateInfo(state.desk[0]);
  renderDeskLevel(state.desk[0].children || []);
}

function renderDeskLevel(items: DataItem[]): void {
  const panel = $(".submenu-right") as HTMLElement | null;
  if (!panel) return;
  panel.innerHTML = "";

  if (state.desk.length > 1) {
    panel.append(
      el("a", {
        className: "back-btn",
        textContent: "Terug",
        onclick: (e: MouseEvent) => {
          e.stopPropagation();
          state.desk.pop();
          const p = state.desk.length ? state.desk[state.desk.length - 1] : undefined;
          if (!p) return;
          renderDeskLevel(p.children || []);
          updateInfo(p);
        }
      } as any)
    );
  }

  const ul = el("ul", { id: "submenu-list", className: "submenu-list" });
  for (let i = 0; i < (items || []).length; i++) {
    const it = items[i];
    ul.append(
      buildItemNode(it, {
        withDesc: true,
        onEnterChild: (x: DataItem) => {
          state.desk.push(x);
          updateInfo(x);
          renderDeskLevel(x.children || []);
        }
      })
    );
  }
  panel.append(ul);
}

/* Klik buiten megamenu → sluiten
document.addEventListener("click", e => {
  const s = $("#submenu") as HTMLElement | null;
  if (!s || s.classList.contains("d-none")) return;
  const keep = [
    "#submenu",
    "#main-menu",
    "#nav-desktop",
    ".side-header",
    ".top-menu",
    ".submenu-right",
    ".submenu-list",
    ".item-subblock",
    ".item-link",
    ".megamenu",
    ".offcanvas"
  ].join(",");
  const target = e.target as Element;
  if (!target.closest(keep)) closeMegamenu();

// Extra regel: klik op margin van header container → sluiten
  if (target.closest("body.to-shine-variation-centered header .container")) {
    const rect = (target.closest("body.to-shine-variation-centered header .container") as HTMLElement).getBoundingClientRect();
    const x = (e as MouseEvent).clientX;
    const y = (e as MouseEvent).clientY;
    // check of klik in de "lege ruimte" (margin) was
    if (x < rect.left || x > rect.right || y < rect.top || y > rect.bottom) {
      closeMegamenu();
    }
  }

});
 */



/* */
// Klik buiten de content-rij (#submenu .row) => sluiten
const shouldIgnore = (el: Element | null) =>
  !!el?.closest(".offcanvas"); // interacties met offcanvas niet laten sluiten (optioneel)

function handleOutsideClick(e: MouseEvent) {
  const panel = document.getElementById("submenu");
  if (!panel || panel.classList.contains("d-none")) return;

  const target = e.target as Element;
  const insideRow = target.closest("#submenu .row");

  if (!insideRow && !shouldIgnore(target)) {
    closeMegamenu();
  }
}

// Gebruik click (en desgewenst pointerdown voor snappier gedrag op touch)
document.addEventListener("click", handleOutsideClick);
// document.addEventListener("pointerdown", handleOutsideClick); // optioneel

/* ==== Mobile (default) ==== */
function renderMobileLevel(items: DataItem[], parent: DataItem | null = null): void {
  const cont = $("#mobile-menu-content") as HTMLElement | null;
  if (!cont) return;
  cont.innerHTML = "";
  const wrap = el("div", { className: "mobile-level" });

  if (parent) {
    wrap.append(
      el("div", {
        className: "mobile-back-btn",
        innerHTML: "Terug",
        onclick: () => {
          state.mob.pop();
          const p = state.mob.length ? state.mob[state.mob.length - 1] : null;
          renderMobileLevel(p ? p.children || [] : data, p);
        }
      } as any),
        el("div", {
          className: "mobile-level-header",
          innerHTML: `<h4>${parent.title}</h4>${parent.desc ? `<p>${parent.desc}</p>` : ""}`,
          onclick: () => {
            if (parent.link && parent.enabled) {
              if (parent.target === "_blank") {
                window.open(parent.link, "_blank");
              } else {
                location.href = parent.link;
              }
            }
          },
          style: parent.link && parent.enabled ? "cursor:pointer" : ""
        })
    );
  }

  const ul = el("ul", { className: "mobile-nav-list" });
  for (let i = 0; i < (items || []).length; i++) {
    const item = items[i];
    const li = el("li", { className: "mobile-nav-item" }) as HTMLLIElement;
    const row = el("div", { className: "mobile-nav-row" });
    const h4 = el("h4");

    if (item.link && item.enabled && !(item.children && item.children.length)) {
      h4.append(el("a", { href: item.link, target: item.target || "_self", textContent: item.title }));
    } else {
      h4.append(el("span", { textContent: item.title }));
    }
    row.append(h4);

    if (parent && item.desc) row.append(el("p", { textContent: item.desc }));

    if (item.children && item.children.length) {
      const go = (ev?: Event) => {
        if (ev && typeof (ev as any).preventDefault === "function") (ev as any).preventDefault();
        const t = (ev?.target as Element) || null;
        if (t && typeof (t as any).closest === "function" && (t as any).closest("a")) return;
        state.mob.push(item);
        renderMobileLevel(item.children!, item);
      };
      row.append(
        el("button", {
          type: "button",
          className: "mobile-next-btn",
          onclick: (e: MouseEvent) => {
            e.stopPropagation();
            go(e);
          }
        } as any)
      );
      li.tabIndex = 0;
      li.setAttribute("role", "button");
      li.setAttribute("aria-label", `${item.title} openen`);
      li.addEventListener("click", go);
      li.addEventListener("keydown", e => {
        const key = (e as KeyboardEvent).key;
        if (key === "Enter" || key === " ") go(e);
      });
    }

    li.append(row);
    ul.append(li);
  }

  wrap.append(ul);
  cont.append(wrap);
}

/* ==== Mobile (scoped: ...1) ==== */
function renderMobileLevel1(items: DataItem[], parent: DataItem | null = null): void {
  const cont = document.getElementById("mobile-menu-content1") as HTMLElement | null;
  if (!cont) return;
  cont.innerHTML = "";

  const wrap = el("div", { className: "mobile-level1" });

  // Header + Terug
  if (parent) {
    wrap.append(
      el("div", {
        className: "mobile-back-btn1",
        innerHTML: "Terug",
        onclick: () => {
          if (state.mob1.length) state.mob1.pop();
          const prev = state.mob1.length ? state.mob1[state.mob1.length - 1] : null;
          renderMobileLevel1(prev ? prev.children || [] : mobileMenuData1, prev);
        }
      } as any),
      el("div", {
        className: "mobile-level-header1",
        innerHTML: `<h4>${parent.title}</h4>${parent.desc ? `<p>${parent.desc}</p>` : ""}`
      })
    );
  }

  const ul = el("ul", { className: "mobile-nav-list1" });

  for (let i = 0; i < (items || []).length; i++) {
    const item = items[i];
    const li = el("li", { className: "mobile-nav-item1" }) as HTMLLIElement;
    const row = el("div", { className: "mobile-nav-row1" });
    const h4 = el("h4");

    if (item.link && item.enabled && !(item.children && item.children.length)) {
      h4.append(el("a", { href: item.link, target: item.target || "_self", textContent: item.title }));
    } else {
      h4.append(el("span", { textContent: item.title }));
    }
    row.append(h4);

    if (parent && item.desc) row.append(el("p", { textContent: item.desc }));

    if (item.children && item.children.length) {
      const go = (ev?: Event) => {
        if (ev && typeof (ev as any).preventDefault === "function") (ev as any).preventDefault();
        const t = (ev?.target as Element) || null;
        if (t && typeof (t as any).closest === "function" && (t as any).closest("a")) return;
        state.mob1.push(item);
        renderMobileLevel1(item.children!, item);
      };

      row.append(
        el("button", {
          type: "button",
          className: "mobile-next-btn1",
          onclick: (e: MouseEvent) => {
            e.stopPropagation();
            go(e);
          }
        } as any)
      );

      li.tabIndex = 0;
      li.setAttribute("role", "button");
      li.setAttribute("aria-label", `${item.title} openen`);
      li.addEventListener("click", go);
      li.addEventListener("keydown", e => {
        const key = (e as KeyboardEvent).key;
        if (key === "Enter" || key === " ") go(e);
      });
    }

    li.append(row);
    ul.append(li);
  }

  wrap.append(ul);
  cont.append(wrap);
}

/* ==== Init & cross-talk ==== */
document.addEventListener("DOMContentLoaded", () => {
  renderMainMenu();
  renderMobileLevel(data);
  renderMobileLevel1(mobileMenuData1); // scoped menu

  // Als een (Bootstrap) dropdown opent, sluit megamenu
  document.addEventListener("show.bs.dropdown" as any, closeMegamenu);

  // Klik op dropdown-toggle → megamenu dicht
  $$<HTMLElement>('[data-bs-toggle="dropdown"],.dropdown-toggle,[data-toggle="dropdown"]').forEach(t =>
    t.addEventListener("click", closeMegamenu)
  );

  // Klik op megamenu (hoofdnavigatie) → alle dropdowns dicht (incl. "Over ons")
  document.addEventListener("click", e => {
    const target = e.target as Element;
    if (target.closest("#main-menu .nav-item, #main-menu .nav-link")) closeDropdowns();
  });

  // Klik op overlay → megamenu sluiten
  document.getElementById("menu-overlay")?.addEventListener("click", closeMegamenu);

});

// Toggle sections
document.querySelectorAll<HTMLElement>('.toggle-title').forEach(title => {
  title.addEventListener('click', () => {
    const content = title.nextElementSibling as HTMLElement | null;
    if (!content) return;

    const isOpen = content.style.display === 'block';

    content.style.display = isOpen ? 'none' : 'block';

    const icon = title.querySelector<HTMLElement>('.toggle-icon');
    if (icon) {
      icon.classList.toggle('is-rotated', !isOpen);
    }
  });
});

(() => {
  const storageKey = "translationNoticeDismissed";
  const notice = document.getElementById("translationNotice") as HTMLElement | null;
  if (!notice) return;

  // Only show on kinderpalliatief.nl/en/...
  const host = window.location.hostname.toLowerCase();
  const path = window.location.pathname; // keeps leading "/"

  const allowedHost = host === "kinderpalliatief.nl" || host === "www.kinderpalliatief.nl";
  const allowedPath = path === "/en" || path.startsWith("/en/");

  if (!allowedHost || !allowedPath) {
    // Not on the English section -> never visible
    notice.remove();
    return;
  }

  // If dismissed, remove permanently
  if (localStorage.getItem(storageKey) === "true") {
    notice.remove();
    return;
  }

  // Otherwise show (starts hidden => no flash)
  notice.hidden = false;

  notice.addEventListener("closed.bs.alert", () => {
    localStorage.setItem(storageKey, "true");
  });
})();
